import { render } from "./WhatsAppIntegrationPanel.vue?vue&type=template&id=26217b83&scoped=true"
import script from "./WhatsAppIntegrationPanel.vue?vue&type=script&lang=js"
export * from "./WhatsAppIntegrationPanel.vue?vue&type=script&lang=js"

import "./WhatsAppIntegrationPanel.vue?vue&type=style&index=0&id=26217b83&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26217b83"]])

export default __exports__